export const CollapseIcon = ({ className, size = 24 }: { className?: string; size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      className={className}
    >
      <g
        style={{
          stroke: 'none',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'none',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          d="M 73.915 16.085 c -0.781 -0.781 -2.047 -0.781 -2.828 0 L 44.938 42.233 V 28.106 c 0 -1.104 -0.896 -2 -2 -2 s -2 0.896 -2 2 v 18.955 c 0 0.131 0.014 0.262 0.039 0.392 c 0.012 0.06 0.034 0.115 0.051 0.173 c 0.02 0.067 0.035 0.135 0.062 0.2 c 0.028 0.069 0.067 0.131 0.103 0.196 c 0.027 0.049 0.049 0.101 0.081 0.148 c 0.146 0.219 0.335 0.408 0.554 0.555 c 0.049 0.033 0.103 0.056 0.155 0.084 c 0.063 0.034 0.123 0.072 0.19 0.1 c 0.066 0.027 0.135 0.043 0.203 0.063 c 0.057 0.017 0.112 0.039 0.171 0.051 c 0.129 0.026 0.26 0.039 0.392 0.039 h 18.955 c 1.104 0 2 -0.896 2 -2 s -0.896 -2 -2 -2 H 47.767 l 26.148 -26.148 C 74.696 18.132 74.696 16.866 73.915 16.085 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 35.497 62.503 c -1.104 0 -2 -0.896 -2 -2 v -4 h -4 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 6 c 1.104 0 2 0.896 2 2 v 6 C 37.497 61.607 36.601 62.503 35.497 62.503 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 22.331 56.503 h -7.166 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 7.166 c 1.104 0 2 0.896 2 2 S 23.436 56.503 22.331 56.503 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 2 62.503 c -1.104 0 -2 -0.896 -2 -2 v -6 c 0 -1.104 0.896 -2 2 -2 h 6 c 1.104 0 2 0.896 2 2 s -0.896 2 -2 2 H 4 v 4 C 4 61.607 3.104 62.503 2 62.503 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 2 76.835 c -1.104 0 -2 -0.896 -2 -2 v -7.166 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 7.166 C 4 75.939 3.104 76.835 2 76.835 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 8 90 H 2 c -1.104 0 -2 -0.896 -2 -2 v -6 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 4 h 4 c 1.104 0 2 0.896 2 2 S 9.104 90 8 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 22.331 90 h -7.166 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 7.166 c 1.104 0 2 0.896 2 2 S 23.436 90 22.331 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 35.497 90 h -6 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 4 v -4 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 6 C 37.497 89.104 36.601 90 35.497 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 35.497 76.834 c -1.104 0 -2 -0.896 -2 -2 v -7.166 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 7.166 C 37.497 75.938 36.601 76.834 35.497 76.834 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 88 90 H 48.201 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 86 V 4 H 4 v 37.799 c 0 1.104 -0.896 2 -2 2 s -2 -0.896 -2 -2 V 2 c 0 -1.104 0.896 -2 2 -2 h 86 c 1.104 0 2 0.896 2 2 v 86 C 90 89.104 89.104 90 88 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
